// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Inbox } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconInbox(props: any) {
    return <IconBase icon={Inbox} {...props} />
  }

  export default IconInbox
  